import { BoletoGerado } from 'src/servicos/api/tipos'

import { MetodosPagamento } from './enums'
import { Usuario } from './usuario'

export enum EtapaReingresso {
  Regulamento = 1,
  Financeiro = 2,
  PlanoPagamento = 3,
  TermosECondicoes = 4,
  DadosPagamento = 5,
  AguardandoPagamento = 6,
  Concluido = 7
}

export const resolverEtapaReingresso = (
  etapa?: keyof typeof EtapaReingresso | EtapaReingresso | string | number
): keyof typeof EtapaReingresso => {
  if (etapa == null || etapa === '') {
    return 'Regulamento'
  }

  if (typeof etapa === 'string') {
    if (etapa in EtapaReingresso) {
      return etapa as keyof typeof EtapaReingresso
    }

    const etapaNumerica = Number(etapa)
    if (!Number.isNaN(etapaNumerica) && EtapaReingresso[etapaNumerica]) {
      return EtapaReingresso[etapaNumerica] as keyof typeof EtapaReingresso
    }
  }

  if (typeof etapa === 'number' && EtapaReingresso[etapa]) {
    return EtapaReingresso[etapa] as keyof typeof EtapaReingresso
  }

  return 'Regulamento'
}

export const obterValorEtapaReingresso = (
  etapa?: keyof typeof EtapaReingresso | EtapaReingresso | string | number
): EtapaReingresso => EtapaReingresso[resolverEtapaReingresso(etapa)]

export interface Reingresso {
  id?: string
  etapaMatricula: keyof typeof EtapaReingresso
  situacaoMatricula: SituacaoReingresso
  termosCondicoes?: TermosCondicoesReingresso
  responsavelFinanceiro?: ResponsavelFinanceiro
  pagamentoReingresso?: PagamentoReingresso
}

export enum SituacaoReingresso {
  EmailEnviado = 'EmailEnviado',
  TicketCriado = 'TicketCriado',
  Cancelado = 'Cancelado',
  RegulamentoAceito = 'RegulamentoAceito',
  PendenciaFinanceira = 'PendenciaFinanceira',
  FinanceiroAceito = 'FinanceiroAceito',
  Finalizado = 'Finalizado',
  SemTurmaReingresso = 'SemTurmaReingresso'
}

export interface TermosCondicoesReingresso {
  urlTermosCondicoes?: string
  liAceitoTermos: boolean
  estouCiente: boolean
}

export interface ResponsavelFinanceiro {
  possuiResponsavelFinanceiro: boolean
  idUsuarioResponsavel?: string
  enderecoUsuarioMatricula?: boolean
  usuarioResponsavel?: Usuario
}

export interface PagamentoReingresso {
  metodoPagamento: MetodosPagamento
  numeroCartao?: string
  nomeCartao?: string
  validadeCartao?: string
  codigoSeguranca?: string
  parcelas?: string
  diaVencimento?: string
  idCupom?: string
  codigoCupom?: string
  valor?: number
  valorDesconto?: number
  valorTotal?: number
  boletoGerado?: BoletoGerado
}
